import React, { useEffect, useState, useMemo } from "react";
import { Container, Input, Table, FormGroup, Label, Col } from "reactstrap";
import { Formik, Form, Field } from "formik";
import Modal from "react-modal"
import { getCustomStyles } from "../../share/ModalStyle";
import { Loading } from "../../share/loading";
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import * as Yup from "yup";
import "../../share/form.css";
import './ProposalStyle.css'
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { RenderCustomHeader } from "../../share/RenderCustomHeader";
import { ConvertDateToThaiBuddhist } from "../../share/ConvertDateToThaiBuddhist";
import { ConvertDateFormat } from "../../share/ConvertDateFormat";
import { CgClose } from "react-icons/cg";
import { NumericFormat } from 'react-number-format';
import { CustomInputNumeric } from '../../share/CustomInputNumeric'
import Swal from "sweetalert2";
import { AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineClockCircle } from "react-icons/ai";
// import { SearchFilter } from "../../share/SearchFilter";
// import CreateTableProposalComponent from "./CreateTableProposalComponent"; 


export function ProposedToTheSubCommittee3ApproveViewComponent() {
  const myCustomStyles = getCustomStyles()
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  console.log("data", data);
  const [meetingDate, setMeetingDate] = useState("")
  const [meetingYear, setMeetingYear] = useState("")
  const [meetingNo, setMeetingNo] = useState("")
  const [meetingYearSelect, setMeetingYearSelect] = useState([])
  const [meetingNoSelect, setMeetingNoSelect] = useState([]);
  const [modalRecordBorrow, setModalRecordBorrow] = useState(false);
  const ToggleModalRecordBorrow = () => setModalRecordBorrow(!modalRecordBorrow)
  const [selectTrainClassId, setSelectTrainClassId] = useState(null)
  // console.log("selectTrainClassId", selectTrainClassId)
  const [selectDetailTrainClassId, setSelectDetailTrainClassId] = useState(null);
  // console.log("selectDetailTrainClassId", selectDetailTrainClassId);
  // console.log("dataForCheck",dataForCheck)
  const selectOption = [{ id: "1", value: "อนุมัติ" }, { id: "2", value: "ไม่อนุมัติ" }]

  const [modalReason, setModalReason] = useState(false);
  const ToggleModalReason = () => setModalReason(!modalReason);
  const [reasonBorrowId, setReasonBorrowId] = useState(null);


  function GetClassId(trainClassId) {
    setSelectTrainClassId(trainClassId)
    setSelectDetailTrainClassId(data.find((item) => {
      return item.trainClassId === trainClassId
    }))
    ToggleModalRecordBorrow()
  }
  function useInstance(instance) {
    // console.log("instance", instance);
    const { allColumns } = instance;
    // setDataForCheck(data);
    // setDataForCheck(data);
    let rowSpanHeaders = [];


    allColumns.forEach((column, i) => {
      // console.log("column",column)
      const { id, enableRowSpan } = column;
      // console.log("id",id)
      if (enableRowSpan !== undefined) {
        rowSpanHeaders = [
          ...rowSpanHeaders,
          { id, topCellValue: null, topCellIndex: 0, }
        ];
      }
    });
    // console.log("rowSpanHeaders",rowSpanHeaders)

    Object.assign(instance, { rowSpanHeaders });
  }

  const columns = useMemo(
    () => [

      {
        Header: "ข้อมูลผู้ขอกู้",
        columns: [
          {
            Header: "ลำดับ",
            accessor: 'No',
            id: "No",
            enableRowSpan: true,
            // accessor: (_row, i) => i + 1,
            // Cell: (row) => {
            //   return <div>{Number(row.row.id) + 1}</div>;
            // },
            // accessor: "borrowId",
          },
          {
            Header: "เลขที่คำขอ",
            accessor: "borrowNumber",
            enableRowSpan: true,


          },
          {
            Header: "ผู้ขอกู้",
            accessor: "employee",
            enableRowSpan: true,

          },
          {
            Header: "ประเภท",
            accessor: "borrowType",
            enableRowSpan: true
          },
          {
            Header: "ประเภทกิจการ",
            accessor: "businessType",
            enableRowSpan: true,

          },
          {
            Header: "สาขาอาชีพ",
            accessor: "lawOccupationName",
            enableRowSpan: true,
            Cell: ({ value }) => (
              <>{value ? value : "-"}</>
            ),

          },
          {
            Header: "ทุนจดทะเบียน",
            accessor: "registeredCapital",
            enableRowSpan: true,
            Cell: ({ value }) => (
              <>{value ? NumberWithCommas(value) : "-"}</>
            ),
          },
          {
            Header: "จำนวนลูกจ้างทั้งสิ้น (คน)",
            accessor: "employeeAmount",
            Cell: ({ value }) => {
              // console.log("value",value)
              return (
                <>{value ? NumberWithCommas(Number(value)) : "-"}</>
              )
            },
            enableRowSpan: true,

          },
          {
            Header: "ประเภทการฝึก",
            accessor: "inOutTypeName",
            Cell: ({ value }) => (
              <>{value ? value : "-"}</>
            ),
            enableRowSpan: true,

          },

          {
            Header: "รวมจำนวนคน",
            accessor: "amountPersonTotal",
            Cell: ({ value }) => (
              <>{value ? value : "-"}</>
            ),
            enableRowSpan: true,

          },
          // amountApproveTotal: borrow.amountApproveTotal,
          // amountLimitTotal: borrow.amountLimitTotal,
          // amountCourseTotal: borrow.amountCourseTotal,
          // amountClassTotal: borrow.amountClassTotal,
          // amountPersonTotal: borrow.amountPersonTotal,
        ]
      },

      {
        Header: "รายละเอียดการขอกู้ยืมเงิน",
        columns: [
          {
            Header: "หลักสูตร",
            accessor: "trainCourseId",
            Cell: ({ row, value }) => (
              <>{row.original.courseName}</>
            ),
            enableRowSpan: true

          },
          // {
          //   Header: "สาขาอาชีพ",
          //   accessor: "occupationTrain",
          //   enableRowSpan: true,
          // },
          {
            Header: "จำนวนรุ่น",
            accessor: "classAmount",
            enableRowSpan: true
          },
          {
            Header: "ระยะเวลาการฝึกอบรม (ขั่วโมง)",
            accessor: "periodTrainCourse",
            Cell: ({ row, value }) => (
              <>
                {value} ชั่วโมง
                <div>({row.original.dayAmount} วัน)</div>
              </>
            )
          },
          {
            Header: "วันที่เริ่มฝึก",
            accessor: "startDate",
            Cell: ({ row, value }) => (
              <>
                <div>{value}</div>
                (รุ่นที่ {row.original.classItem})
              </>
            ),
          },
          {
            Header: "วันที่จบการฝึก",
            accessor: "endDate",
            Cell: ({ row, value }) => (
              <>
                <div>{value}</div>
                (รุ่นที่ {row.original.classItem})
              </>
            ),
          },
          {
            Header: "จำนวน (คน)",
            accessor: "classEmployeeAmount"
          },
          {
            Header: "วงเงินที่ขอกู้ (บาท)",
            accessor: "payment",
            Cell: ({ value }) => (
              <>{value ? NumberWithCommas(value) : "-"}</>
            )
          },
          {
            Header: "รวมวงเงินที่ขอกู้ (บาท)",
            accessor: "amountLimitTotal",
            Cell: ({ value }) => (
              <>{value ? value : "-"}</>
            ),
            enableRowSpan: true,

          },
          {
            Header: "รวมวงเงินที่ได้รับอนุมัติ (บาท)",
            accessor: "amountApproveTotal",
            Cell: ({ value }) => (
              <>{value ? value : "-"}</>
            ),
            enableRowSpan: true,

          },
          {
            Header: "สถานะ",
            accessor: "statusApprove",
            Cell: ({ row }) => {
              const s = row.original.statusApprove;
              const isApproved = String(s) === "1";
              const isPending = s === null || s === undefined || s === "";
              if (isApproved) {
                return (
                  <span className="status-badge" style={{ background: "#E8F6EE", color: "#0F8A5F" }}>
                    <AiOutlineCheckCircle size={18} />
                    อนุมัติแล้ว
                  </span>
                );
              }
              if (isPending) {
                return (
                  <span className="status-badge" style={{ background: "#FFF6E5", color: "#B26A00" }}>
                    <AiOutlineClockCircle size={18} />
                    รอการอนุมัติ
                  </span>
                );
              }
              return (
                <span className="status-badge" style={{ background: "#FDECEC", color: "#B42318" }}>
                  <AiOutlineCloseCircle size={18} />
                  ไม่อนุมัติ
                </span>
              );
            },
          },

          {
            Header: "",
            accessor: "trainClassId",
            Cell: (cellInfo) => {
              // console.log("cellInfo",cellInfo)
              return (
                <button
                  type="button"
                  className="my-3 btn-green mx-2"
                  onClick={() => GetClassId(cellInfo.value)}
                >
                  บันทึกผลการพิจารณา
                </button>
              )

            },
            enableRowSpan: true
          },

        ]
      },
      {
        Header: "หน่วยงานที่รับคำขอกู้ยืม",
        accessor: "site",
        enableRowSpan: true
      }

    ],
    [data]
  );

  useEffect(() => {
    GetBorrowThree()
  }, [meetingNo, meetingYear, meetingDate])

  async function GetBorrowThree() {
    setLoading(true)
    try {
      let res = await fetch(`api/ProposalBorrow/getResultProposalTrain/${meetingNo}/${meetingYear}/${meetingDate}`);
      let resJson = await res.json();
      let newData = [];
      console.log("resJson", resJson.dataenum)
      await resJson.dataenum?.forEach((borrow, index) => {
        borrow.courseTrains?.forEach((course) => {
          course.classTrains?.forEach((trainClass) => {
            newData.push({
              No: index + 1,
              borrowId: borrow.borrowId,
              borrowNumber: borrow.borrowNumber,
              employee: borrow.employee,
              borrowType: borrow.borrowType,
              businessType: borrow.businessType,
              registeredCapital: borrow.registeredCapital,
              employeeAmount: borrow.employeeAmount,
              name: borrow.name,
              position: borrow.position,
              site: borrow.site,
              trainCourseId: course.trainCourseId,
              courseName: course.courseName,
              inOutTypeName: course.inOutTypeName,
              trainingTypeName: course.trainingTypeName,
              occupationTrain: course.occupationTrain,
              classAmount: course.classAmount,
              startDate: trainClass.startDate,
              endDate: trainClass.endDate,
              amountApprove: trainClass.amountApprove,
              statusApprove: trainClass.statusApprove,
              dayAmount: trainClass.dayAmount,
              payment: trainClass.payment,
              classEmployeeAmount: trainClass.employeeAmount,
              periodTrainCourse: course.periodTrainCourse,
              classItem: trainClass.classItem,
              trainClassId: trainClass.trainClassId,
              amountApproveTotal: borrow.amountApproveTotal,
              amountLimitTotal: borrow.amountLimitTotal,
              amountCourseTotal: borrow.amountCourseTotal,
              amountClassTotal: borrow.amountClassTotal,
              amountPersonTotal: borrow.amountPersonTotal,
              lawOccupationName: borrow.lawOccupationName
            })
          })
        })
      })
      setData(newData)
    } catch (e) {
      console.log("err =>", e)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    async function GetMeetingForSelect() {
      setLoading(true)
      try {
        let res = await fetch(`api/ProposalBorrow/getMeetingNoSelect`);
        let resJson = await res.json();
        setMeetingNoSelect(resJson.dataenum);
      } catch (e) {
        console.log("err =>", e)
      } finally {
        setLoading(false)
      }
    }
    GetMeetingForSelect()

  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    rowSpanHeaders,

    page,
    // nextPage,
    // previousPage,
    // canNextPage,
    // canPreviousPage,
    // pageOptions,
    // gotoPage,
    // pageCount,
    setPageSize,
    state,
    // setGlobalFilter
  } = useTable({
    columns,
    data
  },
    (hooks) => { hooks.useInstance.push(useInstance) },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { globalFilter, pageIndex, pageSize } = state

  const fromInitialValues = {
    meetingNo: "",
    meetingYear: "",
    meetingDate: ""
  }

  const recordBorrowInititalValue = {
    borrowId: selectDetailTrainClassId?.borrowId ?? "",
    trainClassId: selectTrainClassId,
    amount: selectDetailTrainClassId?.payment ?? "",
    approveStatus: selectDetailTrainClassId?.statusApprove ?? "",
    approveAmount: selectDetailTrainClassId?.amountApprove ? selectDetailTrainClassId?.amountApprove : "",
    // rejectRemark: selectDetailTrainClassId?.rejectRemark ?? ""
  }
  const recordBorrowValidationSchema = Yup.object().shape({
    approveStatus: Yup.string().oneOf(["1", "2"]).required("กรุณาระบุ"),
    approveAmount: Yup.string().when("approveStatus", {
      is: "1",
      then: Yup.string().required("กรุณาระบุจำนวนเงิน"),
    }),
    // rejectRemark: Yup.string().when("approveStatus", {
    //   is: "2",
    //   then: Yup.string().trim().required("กรุณาระบุสาเหตุที่ไม่อนุมัติ"),
    //   otherwise: Yup.string().nullable(),
    // }),
  })

  async function saveAdjustReason(remark) {
    try {
      let postData = new FormData();
      postData.append("borrowId",reasonBorrowId);
      postData.append("remark",remark);
      const res = await fetch("api/ProposalBorrow/saveAdjustReason", {
        method: "POST",
        // headers: { "Content-Type": "application/json" },
        body: postData,
      });
      const resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกสำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then(async (r) => {
          if (r.isConfirmed) {
            await GetBorrowThree();
            // ปิดทั้งโมดัลเหตุผล และโมดัลบันทึกผล
            ToggleModalReason();
            ToggleModalRecordBorrow();
            setSelectDetailTrainClassId(null);
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "บันทึกสาเหตุไม่สำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        });
      }
    } catch (e) {
      console.log("saveAdjustReason error =>", e);
      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาดในการเชื่อมต่อ",
        confirmButtonColor: "#0A66C2",
        confirmButtonText: "ตกลง",
      });
    }
  }


  const recordBorrowOnsubmit = async (values, actions) => {
    // if (Number(values.approveAmount.replace(/,/g, '')) > values.amount) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "บันทึกข้อมูลไม่สำเร็จ",
    //     html: `เนื่องจากจำนวนเงินที่อนุมัติ มีจำนวนมากกว่าวงเงินที่ขอกู้`,
    //     confirmButtonColor: "#0A66C2",
    //     confirmButtonText: "ตกลง",
    //   })
    // } else {
    try {
      let res = await fetch("api/ProposalBorrow/recordResultProposalTrainTest", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(values)
      })
      let resJson = await res.json();
      if (resJson.status === 1) {
        if (resJson.dataenum.isLastRecord && resJson.dataenum.isEqualApproveAmt == false) {

          setReasonBorrowId(resJson?.dataenum?.borrowId ?? null);
          setModalReason(true);
        } else {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
          }).then(async (result) => {
            if (result.isConfirmed) {
              await GetBorrowThree()
              ToggleModalRecordBorrow()
              setSelectDetailTrainClassId(null)
            }
          })
        }

      } else {
        Swal.fire({
          icon: "error",
          title: "มีบางอย่างผิดปกติ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        })
      }
      GetBorrowThree()

    } catch (e) {
      console.log("err =>", e)
    }
    // }

  }




  return (
    <Formik
      initialValues={fromInitialValues}
      enableReinitialize
    >
      {({ values, errors, touched, setFieldValue, handleBlur, handleChange }) => {

        async function getYearForSelect(e) {
          let postData = new FormData()
          postData.append("meetingNo", e.target.value)
          // console.log("meetingNo", e.target.value)
          try {
            let res = await fetch("api/ProposalBorrow/getMeetingYearSelect", {
              method: "POST",
              body: postData
            })
            let resJson = await res.json()
            setMeetingYearSelect(resJson.dataenum)
          } catch (e) {
            console.log("err", e)
          }
        }
        return (
          <Container>
            {!loading ? (
              <>
                <Modal
                  isOpen={modalRecordBorrow}
                  onRequestClose={ToggleModalRecordBorrow}
                  style={myCustomStyles}
                >
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "960px", width: "100%" }}>บันทึกผลการพิจารณา</h3>
                    <CgClose onClick={ToggleModalRecordBorrow} className="style-iconmodal" />
                  </div>
                  <hr />
                  <Formik
                    initialValues={recordBorrowInititalValue}
                    validationSchema={recordBorrowValidationSchema}
                    onSubmit={recordBorrowOnsubmit}
                    enableReinitialize
                  >
                    {({ values, errors, touched, setFieldValue, handleBlur, handleChange, handleSubmit }) => {
                      return (
                        <Form autoComplete="off" className="px-5">
                          <div>
                            <FormGroup>
                              <h5>ข้อมูลผู้ขอกู้</h5>
                            </FormGroup>

                            <FormGroup>
                              เลขที่คำขอ
                              <span className="mx-1 input-color">{selectDetailTrainClassId?.borrowNumber}</span>
                            </FormGroup>
                            <FormGroup>
                              ชื่อผู้ขอกู้
                              <span className="mx-1 input-color">{selectDetailTrainClassId?.employee}</span>
                            </FormGroup>
                            <FormGroup>
                              หลักสูตร
                              <span className="mx-1 input-color">{selectDetailTrainClassId?.courseName}</span>
                              รุ่นที่
                              <span className="mx-1 input-color">{selectDetailTrainClassId?.classItem}</span>
                              สาขาอาชีพ
                              <span className="mx-1 input-color">{selectDetailTrainClassId?.occupationTrain}</span>
                            </FormGroup>
                            <FormGroup>
                              วันที่เริ่มฝึก
                              <span className="mx-1 input-color">{selectDetailTrainClassId?.startDate}</span>
                              วันที่สิ้นสุดการฝึก
                              <span className="mx-1 input-color">{selectDetailTrainClassId?.endDate}</span>
                            </FormGroup>
                            <FormGroup>
                              วงเงินที่ขอกู้
                              <span className="mx-1 input-color">{NumberWithCommas(Number(selectDetailTrainClassId?.payment))}</span>
                              บาท
                            </FormGroup>

                          </div>
                          <FormGroup>
                            <Label>สถานะ</Label>
                            <Input
                              type="select"
                              name="approveStatus"
                              id="approveStatus"
                              className={`rounded-pill input-color text-center ${errors.approveStatus ? "input-error" : ""}`}
                              // className="rounded-pill input-color text-center"
                              onChange={(e) => {
                                handleChange(e)
                                if (e.target.value !== "1") {
                                  setFieldValue("approveAmount", "")
                                }
                                if (e.target.value === "1") {
                                  // อนุมัติ: ล้างเหตุผลไม่อนุมัติ
                                  // setFieldValue("rejectRemark", "")
                                } else {
                                  // ไม่อนุมัติ: ล้างจำนวนเงินอนุมัติ
                                  setFieldValue("approveAmount", "")
                                }

                              }}
                              onBlur={handleBlur}
                              value={values.approveStatus}

                            >
                              <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                              {selectOption.map((item) => (
                                <option key={item.id} value={item.id}>{item.value}</option>
                              ))}
                            </Input>
                          </FormGroup>

                          <FormGroup>
                            <Label>จำนวนเงินที่อนุมัติ</Label>
                            <Field name="approveAmount">
                              {({ field, meta, form: { setFieldValue, values } }) => (
                                <NumericFormat
                                  {...field}
                                  isAllowed={false}
                                  allowLeadingZeros
                                  thousandSeparator=","
                                  decimalScale={2}
                                  isNumericString={true}
                                  displayType="number"
                                  disabled={values.approveStatus !== "1" ? true : false}
                                  value={values.approveAmount}
                                  // format={(value) => value.toLocaleString()}
                                  customInput={CustomInputNumeric}
                                  onValueChange={(values, sourceInfo) => {
                                    setFieldValue(field.name, values.value)
                                  }}
                                  className={meta.error && meta.touched ? "input-error" : ""}
                                />

                              )}
                            </Field>
                          </FormGroup>

                          {/* <FormGroup>
                            <Label>สาเหตุที่ไม่อนุมัติ</Label>
                            <Field name="rejectRemark">
                              {({ field, meta, form: { values } }) => (
                                <Input
                                  type="textarea"
                                  rows="3"
                                  {...field}
                                  placeholder="กรุณาระบุเหตุผล"
                                  disabled={values.approveStatus !== "2"}
                                  className={meta.error && meta.touched ? "input-error" : ""}
                                />
                              )}
                            </Field>
                            {touched.rejectRemark && errors.rejectRemark ? (
                              <div className="error-text">{errors.rejectRemark}</div>
                            ) : null}
                          </FormGroup> */}

                          <div className="d-flex justify-content-center align-items-center">
                            <button disabled={selectDetailTrainClassId?.amountApprove ? true : false} className="btn-blue w-25 mx-2">บันทึก</button>
                            {/* <button className="btn-blue w-25 mx-2">บันทึก</button> */}

                            <button className="btn-red w-25 mx-2" onClick={() => ToggleModalRecordBorrow()}>ยกเลิก</button>
                          </div>
                        </Form>
                      )
                    }}


                  </Formik>

                </Modal>

                <Modal
                  isOpen={modalReason}
                  onRequestClose={ToggleModalReason}
                  style={myCustomStyles}
                >
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "960px", width: "100%" }}>
                      ระบุสาเหตุของการปรับลดวงเงิน / ไม่อนุมัติ
                    </h3>
                    <CgClose onClick={ToggleModalReason} className="style-iconmodal" />
                  </div>
                  <hr />

                  <Formik
                    initialValues={{ remark: "" }}
                    validationSchema={Yup.object({
                      remark: Yup.string().trim().required("กรุณาระบุสาเหตุ"),
                    })}
                    onSubmit={async (vals) => {
                      await saveAdjustReason(vals.remark);
                    }}
                  >
                    {({ values, errors, touched, handleChange, handleBlur }) => (
                      <Form autoComplete="off" className="px-5">
                        {/* <FormGroup>
                          <Label>Borrow ID</Label>
                          <div className="input-color">{reasonBorrowId ?? "-"}</div>
                        </FormGroup> */}

                        <FormGroup>
                          <Label>สาเหตุ</Label>
                          <Input
                            type="textarea"
                            name="remark"
                            rows="4"
                            placeholder="กรุณาระบุสาเหตุของการปรับลดวงเงินหรือไม่อนุมัติ"
                            value={values.remark}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className={touched.remark && errors.remark ? "input-error" : ""}
                          />
                          {touched.remark && errors.remark ? (
                            <div className="error-text">{errors.remark}</div>
                          ) : null}
                        </FormGroup>

                        <div className="d-flex justify-content-center align-items-center">
                          <button type="submit" className="btn-blue w-25 mx-2">บันทึก</button>
                          <button type="button" className="btn-red w-25 mx-2" onClick={ToggleModalReason}>
                            ยกเลิก
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Modal>

                <div className="mb-2">
                  <Form
                    className=""
                    // onSubmit={handleSubmit}
                    autoComplete="off"
                  >
                    <FormGroup row>
                      <Label for="" sm={1}>
                        ครั้งที่
                      </Label>
                      <Col sm={3}>
                        <Input
                          name="meetingNo"
                          type="select"
                          className="text-center w-100 rounded-pill input-color"
                          onChange={(e) => {
                            handleChange(e)
                            getYearForSelect(e)
                            setMeetingNo(e.target.value)
                          }}
                          onBlur={handleBlur}
                          value={values.meetingNo}
                        >
                          <option defaultValue={"กรุณาเลือก"}>
                            กรุณาเลือก
                          </option>
                          {meetingNoSelect.map((item, k) => (
                            <option key={k} value={item.meetingNo}>
                              {item.meetingNo}
                            </option>
                          ))}
                        </Input>
                      </Col>
                      <Label for="" sm={1}>
                        ปี
                      </Label>
                      <Col sm={3}>
                        <Input
                          name="meetingYear"
                          type="select"
                          className="text-center w-100 rounded-pill input-color"
                          onChange={(e) => {
                            handleChange(e)
                            setMeetingYear(e.target.value)
                          }}
                          onBlur={handleBlur}
                          value={values.meetingYear}
                        >

                          <option defaultValue={"กรุณาเลือก"}>
                            กรุณาเลือก
                          </option>
                          {meetingYearSelect.map((year, i) => (
                            <option key={i} value={year.meetingYear}>
                              {year.meetingYear}
                            </option>
                          ))}
                        </Input>
                      </Col>
                      <Label for="" sm={1}>
                        วันที่
                      </Label>
                      <Col sm={3}>
                        <Field name="meetingDate">
                          {({ field, meta, form }) => {
                            return (
                              <DatePicker
                                selected={field.value ? new Date(field.value) : null}
                                locale="th-buddhist"
                                showIcon
                                calendarClassName="thai-buddhist"
                                dateFormat="dd MMMM yyyy"
                                value={ConvertDateToThaiBuddhist(field.value)}
                                isClearable={true}
                                placeholderText="กรุณาเลือก"
                                renderCustomHeader={RenderCustomHeader}
                                onChange={(date) => {
                                  form.setFieldValue(field.name, ConvertDateFormat(date))
                                  setMeetingDate(ConvertDateFormat(date))
                                }}
                                customInput={
                                  <Input
                                    type="text"
                                    className={
                                      touched.meetingDate && errors.meetingDate
                                        ? "input-error rounded-pill text-center input-color custom-placeholder"
                                        : "rounded-pill text-center input-color custom-placeholder"
                                    }
                                    value={ConvertDateToThaiBuddhist(field.value)}
                                    onChange={() => { }}
                                    onBlur={field.onBlur}
                                  />
                                }
                              />
                            )
                          }}
                        </Field>
                      </Col>

                    </FormGroup>
                  </Form>

                </div>
                <div className="d-flex justify-content-end align-items-center mt-3">
                  <div className="d-flex align-items-center ">
                    <span className="me-2">
                      แสดง {" "}
                    </span>

                    <Input className="input-color rounded-pill" type="select" value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                      {
                        [5, 10, 25, 50, 75, 100].map(pageSize => (
                          <option key={pageSize} value={pageSize}>
                            {pageSize}
                          </option>
                        ))
                      }
                    </Input>
                    <span className="mx-2">{" "} รายการ {" "}</span>

                  </div>
                  {/* <SearchFilter search={globalFilter} setSearch={setGlobalFilter}/> */}
                </div>
                <div style={{ overflowX: "auto" }} className="mt-3">
                  <Table style={{ minWidth: "max-content", outline: "none" }} className="styled-table text-center" bordered {...getTableProps()}>
                    <thead className='styles-thead'>

                      {headerGroups.map((headerGroup) => {
                        return (
                          <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => {
                              return (
                                <th {...column.getHeaderProps()}>
                                  {column.render("Header")}
                                </th>
                              )

                            })}
                          </tr>
                        )
                      })}
                    </thead>


                    <tbody {...getTableBodyProps()}>
                      {rows.map((row, i) => {
                        prepareRow(row);
                        // console.log("row", row)
                        // console.log("pagesize", pageSize)
                        // console.log("data", data)
                        for (let j = 0; j < row.allCells.length; j++) {
                          let cell = row.allCells[j];
                          let currentBorrowNumberForCheck = rowSpanHeaders.find((x) => x.id === "borrowNumber");
                          let rowSpanHeader = rowSpanHeaders.find((x) => x.id === cell.column.id);
                          if (rowSpanHeader !== undefined) {

                            if (rowSpanHeader.topCellValue === null || rowSpanHeader.topCellValue !== cell.value) {
                              cell.isRowSpanned = false;
                              rowSpanHeader.topCellValue = cell.value;
                              rowSpanHeader.topCellIndex = i;
                              cell.rowSpan = 1;
                            } else {
                              if (rowSpanHeader.id !== "borrowNumber") {
                                if (currentBorrowNumberForCheck.topCellValue !== data[i !== 0 ? i - 1 : 0].borrowNumber) {
                                  cell.isRowSpanned = false;
                                  rowSpanHeader.topCellValue = cell.value;
                                  rowSpanHeader.topCellIndex = i;
                                  cell.rowSpan = 1;
                                } else {
                                  if (rowSpanHeader.id === "inOutTypeName" || rowSpanHeader.id === "occupationTrain" || rowSpanHeader.id === "classAmount") {
                                    // console.log("inOutTypeName")
                                    if (data[i].trainCourseId === data[i !== 0 ? i - 1 : 0].trainCourseId) {
                                      rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                      cell.isRowSpanned = true;
                                    } else if (rowSpanHeader.id === "registeredCapital") {
                                      rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                      cell.isRowSpanned = true;
                                    } else {
                                      cell.isRowSpanned = false;
                                      rowSpanHeader.topCellValue = cell.value;
                                      rowSpanHeader.topCellIndex = i;
                                      cell.rowSpan = 1;
                                    }
                                  } else {
                                    rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                    cell.isRowSpanned = true;
                                  }
                                }
                              } else {
                                rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                cell.isRowSpanned = true;
                              }
                            }
                          }


                        }
                        return null;
                      })}


                      {!page.length ? (
                        <>
                          <tr>
                            <td className="text-center" colSpan="13">ไม่มีข้อมูล</td>
                          </tr>

                        </>
                      ) : (
                        <>
                          {rows.map((row) => {
                            if (row.original.No > pageSize) {
                              return null
                            } else {
                              return (
                                <tr {...row.getRowProps()}>
                                  {row.cells.map((cell) => {
                                    if (cell.isRowSpanned) {
                                      return null;
                                    } else {
                                      return (
                                        <td rowSpan={cell.rowSpan} {...cell.getCellProps()}>
                                          {cell.render("Cell")}
                                        </td>
                                      );
                                    }

                                  })}
                                </tr>
                              );
                            }
                          })}
                        </>
                      )}

                    </tbody>
                  </Table>

                </div>
                {/* <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <button className="btn border border-1" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>{"หน้าแรก"}</button>
                    <button className="btn border border-1" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>{"หน้าสุดท้าย"}</button>
                  </div>

                  <span className="">
                    หน้าที่ {" "}
                    <span className="page-count">
                      {pageIndex + 1} / {pageOptions.length}
                    </span>
                  </span>
                  <div>
                    <button
                      className="btn border border-1"
                      onClick={() => previousPage()}
                      disabled={!canPreviousPage}
                    >
                      ก่อนหน้า
                    </button>
                    <button
                      className="btn border border-1"
                      onClick={() => nextPage()}
                      disabled={!canNextPage}
                    >
                      ถัดไป
                    </button>
                  </div>
                </div> */}

              </>
            ) : (<Loading />)}

          </Container>
        )
      }}
    </Formik>



  )

}